import { Card, CardContent } from '@/components/ui/card';
import aussiSharesLogo from '@/assets/aussishares-product-logo.png';

const products = [
  {
    name: 'AussiShares',
    url: 'https://aussieshares.lovable.app',
    description: 'Simulate ASX trading — practice stocks, ETFs, bonds, commodities & crypto with virtual money, zero risk.',
  },
];

export default function InceptionGlenPage() {
  return (
    <div className="px-4 pt-6">
      <h1 className="mb-1 font-display text-2xl font-bold">Inception Glen</h1>
      <p className="mb-5 text-sm text-muted-foreground">Other products by the maker of AussiBooks</p>

      <div className="space-y-3">
        {products.map(p => (
          <a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer">
            <Card className="transition-colors hover:bg-muted/50">
              <CardContent className="flex items-center gap-3 p-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl overflow-hidden">
                  <img src={aussiSharesLogo} alt="AussiShares" className="h-10 w-10 object-contain" />
                </div>
                <div className="min-w-0">
                  <p className="font-medium">{p.name}</p>
                  <p className="text-xs text-muted-foreground">{p.description}</p>
                </div>
              </CardContent>
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
}
